import React from 'react';
import { Eyebrow } from './Eyebrow';
import { DELIVERY } from '../data/landing';
export function DeliverySection() {
  return <section className="bg-cream py-14 md:py-20" aria-labelledby="delivery-title" data-id="element-14" data-mp="jfy55nb9hssh">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-15" data-mp="5p1hmaw701sa">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-16" data-mp="aml41y31nkvb">
          <Eyebrow data-id="element-17" data-mp="an2w0iiobcxf">Cómo lo recibes</Eyebrow>
          <h2 id="delivery-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-18" data-mp="ybvx0te5kayw">
            Disponible en cuanto completes tu compra
          </h2>
        </div>

        <ol className="mx-auto mt-8 grid max-w-[900px] gap-3 md:grid-cols-2" data-id="element-19" data-mp="od6fx2u2yujp">
          {DELIVERY.map((item, index) => <li key={item.title} className="flex gap-3.5 rounded-[12px] border border-line bg-cream-soft p-4" data-id="element-20" data-mp="tbhnt80teuza" data-mpi={index}>
              <span className="flex h-7 w-7 flex-none items-center justify-center rounded-[8px] bg-gold/15 text-[11px] font-bold text-gold-muted" data-id="element-21" data-mp="3e431dbl6x9hh">
                {index + 1}
              </span>
              <div data-id="element-22" data-mp="7dchznvu1vlr">
                <h3 className="text-[13px] font-bold text-ink md:text-[14px]" data-id="element-23" data-mp="7dw0b5peam0b">
                  {item.title}
                </h3>
                <p className="mt-1 text-[12px] font-medium leading-relaxed text-ink-muted md:text-[13px]" data-id="element-24" data-mp="ldx34qp803if">
                  {item.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}